/*
 Copyright 2017 New Vector Ltd.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _bluebird = require('bluebird');

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matrixJsSdk = require('matrix-js-sdk');

var _FlairStore = require('../../../stores/FlairStore');

var _FlairStore2 = _interopRequireDefault(_FlairStore);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlairAvatar = function (_React$Component) {
    (0, _inherits3.default)(FlairAvatar, _React$Component);

    function FlairAvatar() {
        (0, _classCallCheck3.default)(this, FlairAvatar);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FlairAvatar.__proto__ || (0, _getPrototypeOf2.default)(FlairAvatar)).call(this));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(FlairAvatar, [{
        key: 'onClick',
        value: function onClick(ev) {
            ev.preventDefault();
            // Don't trigger onClick of parent element
            ev.stopPropagation();
            _dispatcher2.default.dispatch({
                action: 'view_group',
                group_id: this.props.groupProfile.groupId
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var httpUrl = this.context.matrixClient.mxcUrlToHttp(this.props.groupProfile.avatarUrl, 16, 16, 'scale', false);
            var tooltip = this.props.groupProfile.name ? this.props.groupProfile.name + ' (' + this.props.groupProfile.groupId + ')' : this.props.groupProfile.groupId;
            return _react2.default.createElement('img', {
                src: httpUrl,
                width: '16',
                height: '16',
                onClick: this.onClick,
                title: tooltip });
        }
    }]);
    return FlairAvatar;
}(_react2.default.Component);

FlairAvatar.propTypes = {
    groupProfile: _propTypes2.default.shape({
        groupId: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string,
        avatarUrl: _propTypes2.default.string.isRequired
    })
};

FlairAvatar.contextTypes = {
    matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient).isRequired
};

var Flair = function (_React$Component2) {
    (0, _inherits3.default)(Flair, _React$Component2);

    function Flair() {
        (0, _classCallCheck3.default)(this, Flair);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (Flair.__proto__ || (0, _getPrototypeOf2.default)(Flair)).call(this));

        _this2.state = {
            profiles: []
        };
        return _this2;
    }

    (0, _createClass3.default)(Flair, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._unmounted = true;
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this._unmounted = false;
            this._generateAvatars(this.props.groups);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            this._generateAvatars(newProps.groups);
        }
    }, {
        key: '_getGroupProfiles',
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee(groups) {
                var profiles, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, groupId, groupProfile;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                profiles = [];
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 4;
                                _iterator = (0, _getIterator3.default)(groups);

                            case 6:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context.next = 22;
                                    break;
                                }

                                groupId = _step.value;
                                groupProfile = null;
                                _context.prev = 9;
                                _context.next = 12;
                                return (0, _bluebird.resolve)(_FlairStore2.default.getGroupProfileCached(this.context.matrixClient, groupId));

                            case 12:
                                groupProfile = _context.sent;
                                _context.next = 18;
                                break;

                            case 15:
                                _context.prev = 15;
                                _context.t0 = _context['catch'](9);

                                console.error('Could not get profile for group', groupId, _context.t0);

                            case 18:
                                profiles.push(groupProfile);

                            case 19:
                                _iteratorNormalCompletion = true;
                                _context.next = 6;
                                break;

                            case 22:
                                _context.next = 28;
                                break;

                            case 24:
                                _context.prev = 24;
                                _context.t1 = _context['catch'](4);
                                _didIteratorError = true;
                                _iteratorError = _context.t1;

                            case 28:
                                _context.prev = 28;
                                _context.prev = 29;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 31:
                                _context.prev = 31;

                                if (!_didIteratorError) {
                                    _context.next = 34;
                                    break;
                                }

                                throw _iteratorError;

                            case 34:
                                return _context.finish(31);

                            case 35:
                                return _context.finish(28);

                            case 36:
                                return _context.abrupt('return', profiles.filter(function (p) {
                                    return p !== null;
                                }));

                            case 37:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[4, 24, 28, 36], [9, 15], [29,, 31, 35]]);
            }));

            function _getGroupProfiles(_x) {
                return _ref.apply(this, arguments);
            }

            return _getGroupProfiles;
        }()
    }, {
        key: '_generateAvatars',
        value: function () {
            var _ref2 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(groups) {
                var profiles;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(!groups || groups.length === 0)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                _context2.next = 4;
                                return (0, _bluebird.resolve)(this._getGroupProfiles(groups));

                            case 4:
                                profiles = _context2.sent;

                                if (!this.unmounted) {
                                    this.setState({
                                        profiles: profiles.filter(function (profile) {
                                            return profile ? profile.avatarUrl : false;
                                        })
                                    });
                                }

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _generateAvatars(_x2) {
                return _ref2.apply(this, arguments);
            }

            return _generateAvatars;
        }()
    }, {
        key: 'render',
        value: function render() {
            if (this.state.profiles.length === 0) {
                return _react2.default.createElement('div', null);
            }
            var avatars = this.state.profiles.map(function (profile, index) {
                return _react2.default.createElement(FlairAvatar, { key: index, groupProfile: profile });
            });
            return _react2.default.createElement(
                'span',
                { className: 'mx_Flair' },
                avatars
            );
        }
    }]);
    return Flair;
}(_react2.default.Component);

exports.default = Flair;


Flair.propTypes = {
    groups: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

// TODO: We've decided that all components should follow this pattern, which means removing withMatrixClient and using
// this.context.matrixClient everywhere instead of this.props.matrixClient.
// See https://github.com/vector-im/riot-web/issues/4951.
Flair.contextTypes = {
    matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient).isRequired
};
module.exports = exports['default'];
//# sourceMappingURL=Flair.js.map